import React, { useEffect, useRef, useState } from "react";
import { Table } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, } from 'antd';
// import PropTypes from "prop-types";
// or 'antd/dist/antd.less'
// import "./styles.css";
const locale = {
	filterConfirm: "OK",
    filterReset: "Borrar",
};
const x = parseInt(window.innerHeight - 320);
const CustomTable = ({ columns = [], data, pageSize = x / 50, height = x }) => {
    const [columhs, setcolumhs] = useState(columns)
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Buscar`}
                    value={`${selectedKeys[0] || ''}`}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    {/* <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Limpiar
                    </Button> */}
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Cerrar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                text
            ) : (
                text
            ),
    });
    useEffect(() => {
        if (columns.length > 1) {
            columns[0] = {
                ...columns[0],
                ...getColumnSearchProps('Nombre'),
            }
            columns[1] = {
                ...columns[1],
                ...getColumnSearchProps('matricula'),
            }
            setcolumhs(columns)
        }

    }, [columns])

	return (
        <div className="h-full ">
            <Table
				size="middle"
				pagination={{ pageSize: pageSize }}
				className="h-1"
                columns={columhs}
				dataSource={data}
				locale={locale}
                scroll={{ y: height }}
			/>
		</div>
	);
};

export default CustomTable;
